export const summaryRows: string[] = [
  'Volume 01 — Power Distribution Fundamentals: Systems, Voltages, Single-Line Diagrams & Earthing',
  'Volume 02 — Low-Voltage Switchboards, MCCs & Panelboards',
  'Volume 03 — Medium-Voltage Switchgear: Air, SF6, Vacuum & Ring Main Units',
  'Volume 04 — Circuit Breakers, Fuses & Protection Coordination',
  'Volume 05 — Testing, Commissioning & Preventive Maintenance',
  'Volume 06 — Electrical Safety, Arc Flash Awareness & Troubleshooting',
  'Bonus 1 — Power Distribution Formulas & Electrical Calculations Quick-Reference',
  'Bonus 2 — Switchgear & Switchboard Inspection Checklists',
  'Bonus 3 — How to Read Single-Line Diagrams, Control Schematics & Panel Drawings',
  'Bonus 4 — LV & MV Distribution Troubleshooting Field Guide',
  'Bonus 5 — Power Distribution & Switchgear Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
